import { render, staticRenderFns } from "./LeaveEntitlementPolicyNew.vue?vue&type=template&id=5e96cd79"
import script from "./LeaveEntitlementPolicyNew.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementPolicyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports